import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { SettingsProvider } from "@/context/SettingsContext";
import { AuthProvider } from "@/context/AuthContext";
import { BookingProvider } from "@/context/BookingContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Menu from "@/pages/Menu";
import Storia from "@/pages/Storia";
import Galleria from "@/pages/Galleria";
import Eventi from "@/pages/Eventi";
import Aziende from "@/pages/Aziende";
import Recensione from "@/pages/Recensione";
import Contatti from "@/pages/Contatti";
import RestaInContatto from "@/pages/RestaInContatto";
import LinkLanding from "@/pages/LinkLanding";
import Motoraduno from "@/pages/Motoraduno";
import Privacy from "@/pages/Privacy";
import AuthCallback from "@/pages/AuthCallback";
import AdminPage from "@/pages/admin/AdminPage";

const withLayout = (el) => <Layout>{el}</Layout>;

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={withLayout(<Home />)} />
      <Route path="/menu" element={withLayout(<Menu />)} />
      <Route path="/storia" element={withLayout(<Storia />)} />
      <Route path="/galleria" element={withLayout(<Galleria />)} />
      <Route path="/eventi" element={withLayout(<Eventi />)} />
      <Route path="/aziende" element={withLayout(<Aziende />)} />
      <Route path="/recensione" element={withLayout(<Recensione />)} />
      <Route path="/contatti" element={withLayout(<Contatti />)} />
      <Route path="/resta-in-contatto" element={withLayout(<RestaInContatto />)} />
      <Route path="/motoraduno" element={withLayout(<Motoraduno />)} />
      <Route path="/privacy" element={withLayout(<Privacy />)} />
      <Route path="/masetti" element={<LinkLanding />} />
      <Route path="/admin" element={<AdminPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SettingsProvider>
          <AuthProvider>
            <BookingProvider>
              <AppRouter />
              <Toaster position="top-center" richColors />
            </BookingProvider>
          </AuthProvider>
        </SettingsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
